/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MCQResultSummaryScore } from './mCQResultSummaryScore';
import type { MCQResultSummaryMaxScore } from './mCQResultSummaryMaxScore';
import type { MCQResultSummaryPassed } from './mCQResultSummaryPassed';

/**
 * Compact MCQ result summary for lecturer/student task views.
 */
export interface MCQResultSummary {
  score?: MCQResultSummaryScore;
  maxScore?: MCQResultSummaryMaxScore;
  passed?: MCQResultSummaryPassed;
  attempts?: number;
}
